export const ABOUT_CONSTS = {
    GET_ABOUT: "GET_ABOUT",
};
